import { Route, Switch } from "react-router-dom";
import { AppRouteUi } from "../config/appRoute";
import { PageAuth, PageNotFound } from "./pages/";

export function LayoutPublic(): JSX.Element {
  return (
    <div className="site-content-login">
      <div className="container-fluid m-auto">
        <div className="row">
          <main className="">
            <Switch>
              <Route path={AppRouteUi.Login.Root()} component={PageAuth} />
              <Route
                path={AppRouteUi.NotFound.Root()}
                exact
                component={PageNotFound}
              />
            </Switch>
          </main>
        </div>
      </div>
    </div>
  );
}
